import * as React from "react"

import Box, { BoxProps } from "../Box"

export default class HBox extends React.Component<BoxProps> {
    render() {
        return <Box row {...this.props} />
    }
}